
<div class="drawer" [class.active]="drawerVisible" *ngIf="subtitlesClipboard.items.length">
  <div class="drawer-toggle" (click)="toggle()" style="top: 155px">
    <div class="text"><span translate>Subtitles &nbsp;</span><span class="badge badge-info">{{subtitlesClipboard.items.length}}</span><i class="far fa-arrow-up" *ngIf="!drawerVisible"></i><i class="far fa-arrow-down" *ngIf="drawerVisible"></i></div>
  </div>
  <div class="drawer-body">
    <entity-list [entities]="subtitlesClipboard.items" [sortEntityPaths]="['-date']">
      <ng-template entityListItem let-item="entity">
        <div class="list-group-item combi double no-wrap w-100"><a class="list-group-main d-flex align-items-center" routerLink="/media/view/{{root.id}}/{{item.subtitle.id}}">
            <asset-thumbnail class="sm mr-3" [asset]="item.subtitle"></asset-thumbnail>
            <div [title]="item.subtitle.displayName">
              <div class="no-wrap">{{item.subtitle.displayName}}</div>
            </div></a>
          <button class="btn btn-link reveal" (click)="subtitlesClipboard.remove(item)"><i class="far fa-trash-alt"><span class="sr-only" translate>Remove</span></i></button>
        </div>
      </ng-template>
    </entity-list><br>
    <div class="btn-toolbar">
      <button class="btn btn-secondary" (click)="subtitlesClipboard.clear()"><i class="far fa-times"></i><span translate>Clear clipboard</span></button>
    </div>
  </div>
</div>